import React, { useCallback, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { TaskAltOutlined } from '@mui/icons-material';
import { colors } from 'styles/styleVariables';
import { pageAttributesActions } from '@AMIEWEB/Placement/PlacementDetails/Edit/store/placementPageAttributes.redux';
import { ViewEditTaskModal } from '@AMIEWEB/GlobalSearch/Tasks/ViewEditTaskModal/ViewEditTaskModal';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles<{ hasTask: boolean }>()((theme, { hasTask }) => ({
  icon: {
    color: hasTask ? colors.amnLightBlue : colors.darkText,
    opacity: hasTask ? 1 : 0.3,
  },
}));

const XGridTaskCell = ({ hasTask, params }: { hasTask: boolean; params: any }) => {
  const { classes } = useStyles({ hasTask });
  const dispatch = useDispatch();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(0);

  const handleCloseModal = useCallback(() => {
    setIsEditModalOpen(false);
    setSelectedTaskId(0);
    dispatch(pageAttributesActions.setPopperOpen(false));
  }, [dispatch]);

  return (
    <>
      {' '}
      <TaskAltOutlined
        onClick={e => {
          e.stopPropagation();
          const id = Number(params?.row?.assignTaskId);
          if (Number.isFinite(id) && id > 0) {
            setSelectedTaskId(id);
            setIsEditModalOpen(true);
          }
        }}
        classes={{ root: classes.icon }}
      />{' '}
      {isEditModalOpen && selectedTaskId > 0 && (
        <ViewEditTaskModal taskID={selectedTaskId} open={isEditModalOpen} handleClose={handleCloseModal} />
      )}
    </>
  );
};

export default XGridTaskCell;
